import { Link } from 'react-router-dom';

export function KindleCard(): JSX.Element {
  return (
    <Link
      to="/import"
      className="flex items-center gap-4 rounded-3xl bg-paper p-5 shadow-md transition-shadow hover:shadow-lg"
    >
      <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-brown to-brown-soft text-cream-light shadow-md">
        <span className="text-xl" aria-hidden>
          📱
        </span>
      </div>
      <div className="flex-1">
        <p className="font-serif text-base font-semibold text-brown">
          Kindle &amp; Goodreads
        </p>
        <p className="text-xs text-brown-soft">Importe ta bibliothèque</p>
        <p className="mt-1 flex items-center gap-1.5 text-[11px] font-semibold text-sage-dark">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-sage-dark shadow-[0_0_6px] shadow-sage" />
          Importer depuis Goodreads →
        </p>
      </div>
    </Link>
  );
}
